import { useMemo } from 'react'

import ChatInput from '@/components/modules/chat/ChatInput'
import ChatMessageList from '@/components/modules/chat/ChatMessageList'
import { Skeleton } from '@/components/ui/skeleton'
import useChat from '@/hooks/useChatTransport'
import useConversation from '@/hooks/useConversation'
import useConversationActions from '@/hooks/useConversationActions'

interface ExistingChatProps {
  conversationId: string
}

export default function ExistingChat({ conversationId }: ExistingChatProps) {
  const { refetchConversations } = useConversationActions()
  const { conversation, isLoading } = useConversation(conversationId)

  const initialMessages = useMemo(() => conversation?.messages || [], [conversation?.messages])

  const { messages, streamingContent, isStreaming, sendMessage, stop } = useChat({
    conversationId,
    initialMessages,
    initialActiveUserMessageId: conversation?.activeStream?.userMessageId ?? null,
    onConversationCreated: () => refetchConversations(),
  })

  if (isLoading && !conversation) {
    return (
      <div className="flex flex-1 flex-col gap-4 p-4">
        <div className="mx-auto w-full max-w-3xl space-y-4">
          {['sk-right', 'sk-left', 'sk-right-2'].map((key) => (
            <div
              key={key}
              className={`flex ${key.includes('left') ? 'justify-start' : 'justify-end'}`}
            >
              <Skeleton className="h-16 w-2/3 rounded-2xl" />
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <ChatMessageList
        messages={messages}
        streamingContent={streamingContent}
        isStreaming={isStreaming}
      />
      <ChatInput onSend={sendMessage} onStop={stop} isStreaming={isStreaming} />
    </div>
  )
}
